export const LSWorkSessionKey = "ACTIVE-LMRA-WORK-SESSION";
export const WSOSResponseNoOpenSessionFound = 'no-open-session-found';
export const WSVerifyUnknownServerErr = 'unknown-server-error';
export const WSVerifyServerErr404 = 'server-error-404';
export const WSVerifyResponseValidSession = 'session-valid';
export const WSVerifyResponseSessionNotFoundOrClosed = 'session-not-found-or-closed';
export const WSVerifyResponseSessionValidButExpired = 'session-valid-but-expired';